import { useQueryApi } from "api/hooks.ts";
import { currencyApi } from "api/TenantSlug/Currency/api.ts";
import { composeCurrencyQueryOptions } from "api/TenantSlug/Currency/queryOptions.ts";

import GetCurrenciesResponse = App.Http.Responses.Currency.GetCurrenciesResponse;
import GetCurrencyResponse = App.Http.Responses.Currency.GetCurrencyResponse;

// Hook to get list of currencies
export const useGetCurrenciesQuery = (options = {}) => {
    return useQueryApi<GetCurrenciesResponse>({
        queryKey: ["getCurrencies"],
        queryFn: () => currencyApi.index(),
        ...options,
    });
};

// Hook to get a specific currency
export const useGetCurrencyQuery = (currencyId: string, options = {}) => {
    return useQueryApi<GetCurrencyResponse>({
        ...composeCurrencyQueryOptions(currencyId),
        ...options,
    });
};
